export const normalizeAlbumPayload = (payload = {}) => {
  const candidate = payload?.album || payload?.data?.album || payload;
  if (!candidate || typeof candidate !== 'object') {
    return null;
  }

  const id = candidate.id || candidate._id || candidate.album_id || candidate.albumId;
  if (!id) {
    return null;
  }

  const mediaFiles = candidate.media_files || candidate.mediaFiles;
  const mediaFileIds = candidate.media_file_ids || candidate.mediaFileIds;

  let mediaCount = candidate.media_count ?? candidate.mediaCount;
  if (mediaCount == null) {
    if (Array.isArray(mediaFiles)) {
      mediaCount = mediaFiles.length;
    } else if (Array.isArray(mediaFileIds)) {
      mediaCount = mediaFileIds.length;
    } else {
      mediaCount = 0;
    }
  }

  return {
    id,
    title: candidate.title || candidate.name || candidate.metadata?.slug || 'Album senza titolo',
    description: candidate.description || '',
    createdAt: candidate.created_at || candidate.createdAt || null,
    updatedAt: candidate.updated_at || candidate.updatedAt || null,
    mediaCount,
    currentTotalSizeKb: candidate.current_total_size_kb ?? candidate.currentTotalSizeKb ?? null,
    maxTotalSizeKb: candidate.max_total_size_kb ?? candidate.maxTotalSizeKb ?? null,
    maxItems: candidate.max_items ?? candidate.maxItems ?? null,
    tags: Array.isArray(candidate.tags) ? candidate.tags : [],
    coverMediaId: candidate.cover_media_id || candidate.coverMediaId || null,
    isArchived: Boolean(candidate.is_archived ?? candidate.isArchived ?? false),
    metadata: candidate.metadata || {},
  };
};

export const normalizeMediaFilePayload = (input = {}) => {
  const payload = input?.media_file || input?.media || input;
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  const id = payload.id || payload._id || payload.media_id || payload.mediaId || payload.url || payload.public_url;
  if (!id) {
    return null;
  }

  const rawType = payload.media_type || payload.type;
  const type = rawType ? String(rawType).toLowerCase() : 'image';

  const sizeKb = payload.size_kb ?? payload.sizeKb ?? (payload.size ? payload.size / 1024 : null);
  const sizeBytes = payload.size ?? (typeof sizeKb === 'number' ? sizeKb * 1024 : null);

  return {
    id,
    name: payload.name || payload.title || payload.filename || 'Media',
    type,
    url: payload.public_url || payload.url || payload.file_url || payload.fileUrl || null,
    thumbnailUrl: payload.thumbnail_url || payload.thumbnailUrl || null,
    sizeBytes,
    sizeKb,
    subtype: payload.subtype || payload.metadata?.subtype || null,
    description: payload.description || '',
    createdAt: payload.created_at || payload.createdAt || null,
    updatedAt: payload.updated_at || payload.updatedAt || null,
    raw: payload,
  };
};

export const buildMediaCounters = (mediaFiles = []) => {
  return mediaFiles.reduce(
    (acc, file) => {
      if (!file) {
        return acc;
      }

      if (file.type === 'video') {
        acc.videosCount += 1;
      } else {
        acc.imagesCount += 1;
      }

      return acc;
    },
    { imagesCount: 0, videosCount: 0 }
  );
};

export const mergeAlbumWithMedia = (album, mediaFiles = []) => {
  const normalizedAlbum = normalizeAlbumPayload(album);
  if (!normalizedAlbum) {
    return null;
  }

  const normalizedMedia = mediaFiles
    .map((item) => normalizeMediaFilePayload(item))
    .filter(Boolean);

  const counters = buildMediaCounters(normalizedMedia);

  return {
    ...normalizedAlbum,
    files: normalizedMedia,
    filesCount: normalizedMedia.length,
    imagesCount: counters.imagesCount,
    videosCount: counters.videosCount,
  };
};
